module.exports = __webpack_public_path__ + "img/perks_O MLB Shop Logo 1.940b9350.jpg";